<app-toast></app-toast>
<div class="flex flex-row h-screen items-center">
    <app-desktop-sidebar [selectedItemId]="0" class="mobile:hidden"></app-desktop-sidebar>
    <div class="h-screen p-6 overflow-y-auto w-full flex flex-col mobile:p-2">
        <div class="flex flex-col flex-[1]">
            <app-desktop-topbar pageName="{{ 'shared.pages.dashboard' | transloco }}"
                class="mobile:hidden"></app-desktop-topbar>
            <app-mobile-topbar class="hidden mobile:block" [selectedItemId]="0"></app-mobile-topbar>
            <div class="flex gap-6 items-center mobile:justify-evenly">
                <app-tab-button label="{{ 'shared.overview' | transloco }}" link="/dashboard/overview"></app-tab-button>
                <app-tab-button label="{{ 'shared.electricity' | transloco }}" [isActive]="true"
                    link="/dashboard/electricity"></app-tab-button>
                <app-tab-button label="{{ 'shared.gas' | transloco }}" link="/dashboard/gas"></app-tab-button>
            </div>

            <!-- No membership popup -->
            <div class="mt-4">
                <app-no-membership-popup [visible]="!hasPlusSubscription"></app-no-membership-popup>
            </div>

            <!-- Extraction ongoing popup -->
            <div class="mt-4">
                <app-extraction-ongoing-popup [visible]="isExtractionOngoing"></app-extraction-ongoing-popup>
            </div>

            <!-- Electricity costs -->
            <div class="flex flex-wrap gap-2 max-w-ultrawide min-h-[600px] mobile:flex-col mobile:h-auto">
                <!-- Left side -->
                <div
                    class="mt-4 flex-[2] flex flex-col gap-2 rounded-[16px] border-[1px] min-w-[500px] mobile:min-w-[300px] border-border bg-[#FFFFFF] shadow-sm h-auto mobile:w-full">
                    <div class="flex mt-4 justify-between mobile:flex-col">
                        <div class="flex flex-col gap-4 min-h-[70px] justify-between">
                            <div class="flex flex-col flex-grow justify-center text-center">
                                <p class="text-primary font-semibold ml-4 mr-4 mobile:text-sm">{{
                                    'dashboard.electricity_costs' | transloco }}</p>
                            </div>
                            <div class="h-[2px] w-full bg-primary"></div>
                        </div>
                        <div class="min-h-[70px]  flex flex-grow items-end justify-start mobile:hidden">
                            <div class="h-[2px] w-full bg-border"></div>
                        </div>
                        <div class="min-h-[70px] flex gap-2 flex-col justify-between mobile:h-auto mobile:mt-2">

                            <div class="flex flex-wrap gap-2 mr-4 ml-2 items-center mobile:flex-col">
                                <div class="min-w-[250px] desktop:flex-[1] mobile:w-[300px]">
                                    <app-custom-dropdown [options]="locationsDropdownOptions"
                                        [(selectedOption)]="selectedLocationDropdown"
                                        (selectedOptionChange)="locationChange()"></app-custom-dropdown>
                                </div>
                                <div
                                    class="rounded-[16px] flex gap-2 justify-center items-center bg-[#FFFFFF] border-border border-[1px] p-[12px]">
                                    @if(electricityCostsComparisonDate === undefined) {
                                    <p class="mobile:text-sm hover:cursor-pointer min-w-[50px]"
                                        (click)="openComparisonYearSelect()">
                                        {{ 'dashboard.comparison_year' |
                                        transloco }}</p>
                                    <img src="assets/icons/calendar.svg" alt="{{ 'dashboard.calendar' | transloco }}">
                                    } @else {
                                    <p-calendar class="w-[50px]" [(ngModel)]="electricityCostsComparisonDate"
                                        view="year" readonlyInput="true" dateFormat="yy" [minDate]="datePickerMinYear"
                                        [maxDate]="electricityForecastMaxDate" inputStyleClass="text-center w-full pt-1"
                                        (onClose)="loadElectricityComparisonCostsData()" />
                                    <img src="assets/icons/calendar.svg" alt="{{ 'dashboard.calendar' | transloco }}">
                                    }
                                </div>
                                <div
                                    class="rounded-[16px] flex gap-2 justify-center items-center bg-[#FFFFFF] border-border border-[1px] p-[12px]">
                                    <p-calendar class="w-[50px]" [(ngModel)]="electricityCostsDate" view="year"
                                        [minDate]="datePickerMinYear" [maxDate]="electricityForecastMaxDate"
                                        readonlyInput="true" dateFormat="yy" inputStyleClass="text-center w-full pt-1"
                                        (onClose)="loadElectricityCostsData()" />
                                    <img src="assets/icons/calendar.svg" alt="{{ 'dashboard.calendar' | transloco }}">
                                </div>
                            </div>
                            <div class="h-[2px] w-full bg-border mobile:mt-2"></div>
                        </div>
                    </div>

                    <div class="flex flex-col items-center">
                        <div class="flex gap-0 w-[95%] h-auto">
                            <div class="relative h-auto w-[95%] p-4 mobile:p-2">
                                <div class="h-[150px] largeScreen:h-[200px] w-[95%]">
                                    <app-electricity-costs-averages [showDummyData]="showDummyData"
                                        [averagePricePerKWhData]="averagePricePerKWhData"
                                        [forecastedStartMonth]="forecastedStartMonth"></app-electricity-costs-averages>
                                </div>
                                <div class="h-[400px] largeScreen:h-[500px] w-[95%] mobile:h-[300px]">
                                    <app-electricity-costs-chart [showDummyData]="showDummyData"
                                        [invoiceAmountActualData]="invoiceAmountActualData"
                                        [invoiceAmountForecastData]="invoiceAmountForecastData"></app-electricity-costs-chart>
                                </div>
                                <app-complete-energy-profile
                                    [showPopup]="noDataDialogShowCosts"></app-complete-energy-profile>
                            </div>
                            <app-flex-upgrade [showUpgrade]="showUpgradeElectricityCosts"
                                [showTextUnder]="true"></app-flex-upgrade>
                        </div>
                    </div>
                </div>
                <!-- Right side -->
                <div class="mt-4 flex-[1] flex flex-col gap-2 h-auto mobile:w-full min-w-[500px] mobile:min-w-[300px]">
                    <div class="w-full flex flex-col justify-between rounded-[16px] border-[1px] border-border bg-secondary-100 shadow-sm"
                        [ngClass]="[electricityCostsComparisonDate === undefined ? 'h-auto' : 'h-1/2']">
                        <app-comparison-year [showDummyData]="showDummyData" [year]="compariosonCurrentyear"
                            [lastFullMonthCost]="compariosonCurrentlastFullMonthCost"
                            [lastFullMonthkWh]="compariosonCurrentlastFullMonthkWh"
                            [yearToDateCost]="compariosonCurrentyearToDateCost"
                            [yearToDatekWh]="compariosonCurrentyearToDatekWh"
                            [forecastFullYearCost]="compariosonCurrentforecastFullYearCost"
                            [forecastFullYearkWh]="compariosonCurrentforecastFullYearkWh"
                            [showUpgrade]="showUpgradeGeneral"></app-comparison-year>


                    </div>
                    <div class="w-full flex flex-col rounded-[16px] border-[1px] border-border bg-primary-100 shadow-sm h-1/2"
                        *ngIf="electricityCostsComparisonDate !== undefined">
                        <app-comparison-year [isComparisonYear]="true" [showDummyData]="showDummyData"
                            [year]="compariosonOlderyear" [lastFullMonthCost]="compariosonOlderlastFullMonthCost"
                            [lastFullMonthkWh]="compariosonOlderlastFullMonthkWh"
                            [yearToDateCost]="compariosonOlderyearToDateCost"
                            [yearToDatekWh]="compariosonOlderyearToDatekWh"
                            [forecastFullYearCost]="compariosonOlderforecastFullYearCost"
                            [forecastFullYearkWh]="compariosonOlderforecastFullYearkWh"
                            [showUpgrade]="showUpgradeGeneral"></app-comparison-year>


                    </div>
                </div>
            </div>

            <!-- Consumption and costs -->
            <div class="mt-4 flex flex-wrap gap-2 max-w-ultrawide min-h-[600px] mobile:flex-col">
                <!-- Left side -->
                <div
                    class="mt-4 flex-[2] flex flex-col gap-2 rounded-[16px] border-[1px] min-w-[500px] mobile:min-w-[300px] border-border bg-[#FFFFFF] shadow-sm mobile:w-full">
                    <div class="flex mt-4 justify-between mobile:flex-col">
                        <div class="flex flex-col gap-4 min-h-[70px] justify-between">
                            <div class="flex flex-col flex-grow justify-center text-center">
                                <p class="text-primary font-semibold ml-4 mr-4 mobile:text-sm">{{
                                    'dashboard.consumption_details' | transloco }}</p>
                            </div>
                            <div class="h-[2px] w-full bg-primary"></div>
                        </div>
                        <div class="min-h-[70px]  flex flex-grow items-end justify-start mobile:hidden">
                            <div class="h-[2px] w-full bg-border"></div>
                        </div>
                        <div class="min-h-[70px] flex flex-col justify-between mobile:h-auto mobile:mt-2">

                            <div class="flex gap-2 mr-4 items-center mobile:flex-col">
                                <p class="text-sm text-neutral-500">{{ 'dashboard.show_additional_years' | transloco }}
                                </p>
                                <div
                                    class="rounded-[16px] flex gap-2 justify-center items-center bg-[#FFFFFF] border-border border-[1px] p-[12px]">
                                    <p-calendar class="w-[50px]" [(ngModel)]="consumptionAndCostsDate" view="year"
                                        [minDate]="datePickerMinYear" [maxDate]="electricityForecastMaxDate"
                                        readonlyInput="true" dateFormat="yy" inputStyleClass="text-center w-full pt-1"
                                        (onClose)="loadConsumptionAndCostData()" />
                                    <img src="assets/icons/calendar.svg" alt="{{ 'dashboard.calendar' | transloco }}">
                                </div>
                            </div>
                            <div class="h-[2px] w-full bg-border mobile:mt-2"></div>
                        </div>
                    </div>

                    <div class="flex flex-col items-center">
                        <div class="flex gap-0 w-[95%] h-auto">
                            <div class="relative h-auto w-[95%] p-4 mobile:p-2">
                                <div class="h-[500px] largeScreen:h-[800px] mobile:h-[400px] w-[95%]">
                                    <app-consumption-and-costs-chart [showDummyData]="showDummyData"
                                        [consumptionF1]="consumptionF1" [consumptionF2]="consumptionF2"
                                        [consumptionF3]="consumptionF3" [costsActual]="costsActual"
                                        [costsForecast]="costsForecast" [kWhActual]="kWhActual"
                                        [kWhForecast]="kWhForecast" [consumptionF1Forecast]="consumptionF1Forecast"
                                        [consumptionF2Forecast]="consumptionF2Forecast"
                                        [consumptionF3Forecast]="consumptionF3Forecast"
                                        [showForecastData]="showForecastData"></app-consumption-and-costs-chart>
                                </div>
                                <app-complete-energy-profile
                                    [showPopup]="noDataDialogShowConsumptionCosts"></app-complete-energy-profile>
                            </div>
                            <app-flex-upgrade [showUpgrade]="showUpgradeConsumption"
                                [showTextUnder]="true"></app-flex-upgrade>
                        </div>
                    </div>
                </div>
                <!-- Right side -->
                <div class="mt-4 flex-[1] flex flex-col gap-2 mobile:w-full min-w-[500px] mobile:min-w-[300px]">
                    <div
                        class="p-2 flex flex-col justify-between items-center rounded-[16px] border-[1px] border-border bg-[#FBFCFB] shadow-sm h-full">
                        <p class="font-bold text-lg">{{ 'dashboard.annual_consumption_details' | transloco }}</p>
                        <div class="flex flex-col gap-5 items-center justify-between w-full p-4 mobile:p-2">
                            <div class="h-[250px] largeScreen:h-[400px] w-[95%]">
                                <app-consumption-and-costs-doughnut-chart [showDummyData]="showDummyData"
                                    [labels]="cacd_labels" [showData]="cacd_showData"
                                    [totalConsumption]="cacd_totalConsumption"></app-consumption-and-costs-doughnut-chart>
                            </div>
                            <div class="h-[300px] largeScreen:h-[450px] w-[95%]">
                                <app-consumption-and-costs-right-chart [showDummyData]="showDummyData"
                                    [f1data]="cacr_f1data" [f2data]="cacr_f2data" [f3data]="cacr_f3data"
                                    [f1eurperkwh]="cacr_f1eurperkwh" [f2eurperkwh]="cacr_f2eurperkwh"
                                    [f3eurperkwh]="cacr_f3eurperkwh"></app-consumption-and-costs-right-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Cost Analysis -->
            <div
                class="mt-4 flex-[2] flex flex-col gap-2 rounded-[16px] border-[1px] border-border bg-[#FFFFFF] shadow-sm min-w-[500px] mobile:min-w-[300px] mobile:w-full">
                <div class="flex mt-4 justify-between mobile:flex-col">
                    <div class="flex flex-col gap-4 min-h-[70px] justify-between">
                        <div class="flex flex-col flex-grow justify-center text-center">
                            <p class="text-primary font-semibold ml-4 mr-4 mobile:text-sm">{{ 'shared.cost_analysis'
                                |
                                transloco }}</p>
                        </div>
                        <div class="h-[2px] w-full bg-primary"></div>
                    </div>
                    <div class="min-h-[70px]  flex flex-grow items-end justify-start mobile:hidden">
                        <div class="h-[2px] w-full bg-border"></div>
                    </div>
                    <div class="min-h-[70px] flex flex-col justify-between mobile:h-auto mobile:mt-2">

                        <div class="flex gap-2 mr-4 items-center mobile:justify-center">
                            <div
                                class="rounded-[16px] flex gap-2 justify-center items-center bg-[#FFFFFF] border-border border-[1px] p-[12px]">
                                @if(costAnalysisMonth === undefined) {
                                <p class="mobile:text-sm hover:cursor-pointer" (click)="openMonthSelect()">
                                    {{ 'archive.overview.month' |
                                    transloco }}</p>
                                <img src="assets/icons/calendar.svg" alt="{{ 'dashboard.calendar' | transloco }}">
                                } @else {
                                <p-calendar class="w-[90px]" [(ngModel)]="costAnalysisMonth" view="month"
                                    [minDate]="datePickerMinYear" [maxDate]="electricityForecastMaxDate"
                                    readonlyInput="true" dateFormat="MM" inputStyleClass="text-center w-full pt-1"
                                    (onClose)="changeMonth()" />
                                <img src="assets/icons/calendar.svg" alt="{{ 'dashboard.calendar' | transloco }}">
                                }
                            </div>
                            <div
                                class="rounded-[16px] flex gap-2 justify-center items-center bg-[#FFFFFF] border-border border-[1px] p-[12px]">
                                <p-calendar class="w-[50px]" [(ngModel)]="costAnalysisYear" view="year"
                                    [minDate]="datePickerMinYear" [maxDate]="electricityForecastMaxDate"
                                    readonlyInput="true" dateFormat="yy" inputStyleClass="text-center w-full pt-1"
                                    (onClose)="loadCostAnalysisData()" />
                                <img src="assets/icons/calendar.svg" alt="{{ 'dashboard.calendar' | transloco }}">
                            </div>
                        </div>
                        <div class="h-[2px] w-full bg-border mobile:mt-2"></div>
                    </div>
                </div>

                <div
                    class="flex flex-wrap gap-5 desktop:items-stretch justify-evenly mobile:flex-col mobile:gap-2 p-5 mobile:p-2">
                    <div
                        class="flex-[1] border-2 rounded-lg border-border p-6 mobile:w-full mobile:h-[350px] min-w-[300px]">
                        <p class="text-primary text-center font-semibold ml-4 mt-4 mobile:text-sm">
                            {{ 'dashboard.comparison_of_consumption_and_taxable_expenditure' | transloco }}
                        </p>
                        <div
                            class="h-[400px] largeScreen:h-[500px] w-[90%] max-w-[1000px] mobile:w-full mobile:h-[300px]">
                            <app-cost-analysis-chart [showDummyData]="showDummyData"
                                [lineCostTrendData]="capd_lineCostTrendData" [barkWhData]="capd_barkWhData"
                                [inputedPeriods]="capd_inputedPeriods" [kwhDifference]="capd_kwhDifference"
                                [costDifference]="capd_costDifference"></app-cost-analysis-chart>
                        </div>
                    </div>

                    <div
                        class="flex-[1] border-2 rounded-lg border-border p-6 mobile:w-full mobile:h-[400px] min-w-[300px]">
                        <p class="text-primary text-center font-semibold ml-4 mt-4 mobile:text-sm">{{
                            'dashboard.cost_comparison' | transloco }}</p>
                        <div
                            class="relative h-[400px] largeScreen:h-[500px] w-[90%] max-w-[1000px] mobile:w-full mobile:h-[300px]">
                            <app-cost-per-kwh-chart [showDummyData]="showDummyData"
                                [materialCostsDifferenceSign]="materialCostsDifferenceSign"
                                [materialCostsDifference]="materialCostsDifference"
                                [tmsDifferenceSign]="tmsDifferenceSign" [tmsDifference]="tmsDifference"
                                [taxesDifferenceSign]="taxesDifferenceSign" [taxesDifference]="taxesDifference"
                                [additionalChargesDifferenceSign]="additionalChargesDifferenceSign"
                                [additionalChargesDifference]="additionalChargesDifference"
                                [previousPeriodCostPerKwh]="previousPeriodCostPerKwh"
                                [currentPeriodCostPerKwh]="currentPeriodCostPerKwh"
                                [inputedPeriods]="inputedPeriods"></app-cost-per-kwh-chart>

                            <app-no-data-message [(visible)]="noDataPopUp"></app-no-data-message>
                        </div>
                    </div>

                    <div
                        class="flex-[1] flex flex-col gap-2 mobile:w-full min-w-[500px] mobile:min-w-[300px] shadow-sm">
                        <div
                            class="w-full flex flex-col justify-between items-center rounded-[16px] border-[1px] border-border bg-[#FBFCFB] h-full">
                            <div class="flex flex-col gap-4 min-h-[70px] justify-between w-full">
                                <p class="font-semibold text-primary ml-4 mt-4 mobile:text-sm">{{
                                    'dashboard.cost_item_analysis' | transloco }}</p>
                                <div class="flex">
                                    <div class="h-[2px] w-1/2 bg-primary"></div>
                                    <div class="h-[2px] w-1/2 bg-border"></div>
                                </div>

                            </div>


                            <div class="flex flex-col items-center justify-center h-full w-full p-4 mobile:p-2">
                                <div class="h-[400px] largeScreen:h-[500px] w-[90%] max-w-[1000px] mobile:w-full">
                                    <app-cost-break-down-chart [showDummyData]="showDummyData"
                                        [showData]="costBreakdownData"
                                        [totalPricePerUnit]="totalPricePerUnit"></app-cost-break-down-chart>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <app-custom-footer></app-custom-footer>
    </div>
</div>